import { useEffect } from 'react';
import { useQuery } from 'urql';
import PageHeader from '../../../components/PageHeader.jsx';
import StickyActions from '../../../components/StickyActions.jsx';
import { GET_MOVIMIENTO } from './gql.js';

const titleMap = {
  ingreso: 'Detalle de ingreso',
  egreso: 'Detalle de egreso / transferencia',
};

const subtitleMap = {
  ingreso: 'Verificá los datos registrados para este ingreso de stock.',
  egreso: 'Trazabilidad del egreso o transferencia seleccionada.',
};

export default function MovimientoDetail({ movimientoId, tipo = 'ingreso', onBack }) {
  const safeTipo = tipo === 'egreso' ? 'egreso' : 'ingreso';
  const [{ data, fetching, error }, reexecute] = useQuery({
    query: GET_MOVIMIENTO,
    variables: { id: movimientoId },
    pause: !movimientoId,
  });

  useEffect(() => {
    if (movimientoId) reexecute({ requestPolicy: 'network-only' });
  }, [movimientoId, reexecute]);

  const movimiento = data?.stockMovimiento;

  return (
    <div className="mx-auto flex w-full max-w-[1400px] flex-col gap-6 px-6 py-8">
      <PageHeader title={`${titleMap[safeTipo]} ${movimiento ? `#${movimiento.id}` : ''}`.trim()} subtitle={subtitleMap[safeTipo]} />
      <section className="rounded-2xl border border-[rgb(var(--border))] bg-[rgba(var(--panel),0.7)] p-6 shadow-sm">
        {fetching ? <p className="text-sm text-muted">Cargando datos del movimiento…</p>
          : error ? <p className="text-sm text-red-300">{error.message}</p>
            : movimiento ? <div className="space-y-6">
              <dl className="grid grid-cols-12 gap-4 text-sm text-[rgb(var(--fg))]">
                <Info label="Fecha" value={movimiento.fecha ? `${movimiento.fecha}${movimiento.hora ? ` ${movimiento.hora}` : ''}` : '—'} />
                <Info label="Tipo" value={movimiento.tipo} />
                <Info label="Cliente" value={movimiento.cliente || (movimiento.clienteId ? `#${movimiento.clienteId}` : '—')} />
                <Info label="Remito" value={movimiento.remito} />
                <Info label="Usuario" value={movimiento.usuario || (movimiento.usuarioId ? `#${movimiento.usuarioId}` : '—')} />
                <Info label="Cantidad total" value={Number(movimiento.cantidadTotal ?? 0).toLocaleString()} />
              </dl>
              <div className="overflow-hidden rounded-2xl border border-[rgb(var(--border))] bg-[rgba(var(--bg),0.6)]">
                <table className="w-full text-left text-sm">
                  <thead className="bg-[rgba(var(--subpanel),0.35)] text-xs uppercase tracking-wide text-muted">
                    <tr><th className="px-4 py-3">Artículo</th><th className="px-4 py-3 text-right">Cantidad</th><th className="px-4 py-3">Lote</th><th className="px-4 py-3">Vencimiento</th><th className="px-4 py-3">Ubicación origen</th><th className="px-4 py-3">Ubicación destino</th></tr>
                  </thead>
                  <tbody>{movimiento.detalles?.length ? movimiento.detalles.map(item => (
                    <tr key={item.id} className="border-t border-[rgb(var(--border))]/60">
                      <td className="px-4 py-3">{item.articulo?.codigo ? `${item.articulo.codigo} — ` : ''}{item.articulo?.nombre || (item.articuloId ? `#${item.articuloId}` : '—')}</td>
                      <td className="px-4 py-3 text-right">{Number(item.cantidad ?? 0).toLocaleString()}</td>
                      <td className="px-4 py-3">{item.lote || '—'}</td>
                      <td className="px-4 py-3">{item.vencimiento || '—'}</td>
                      <td className="px-4 py-3">{item.ubicacionId || '—'}</td>
                      <td className="px-4 py-3">{item.ubicacionDestinoId || '—'}</td>
                    </tr>
                  )) : <tr><td colSpan={6} className="px-4 py-6 text-center text-sm text-muted">Este movimiento no tiene detalles asociados.</td></tr>}</tbody>
                </table>
              </div>
            </div> : <p className="text-sm text-muted">No encontramos el movimiento solicitado.</p>}
      </section>
      <StickyActions
        left={<button type="button" onClick={onBack} className="rounded-xl border border-[rgb(var(--border))] bg-transparent px-4 py-2 text-sm font-medium text-[rgb(var(--fg))]">Volver</button>}
        right={<p className="text-sm text-muted">El Kardex mantiene la trazabilidad de este movimiento.</p>}
      />
    </div>
  );
}

function Info({ label, value }) {
  return <div className="col-span-12 md:col-span-4"><dt className="font-medium text-muted">{label}</dt><dd className="mt-1">{value || '—'}</dd></div>;
}
